<!----------------------------------WEBSITE MODE---------------------------------------------->

    <!-- <footer> -->
        <div class="footer">
            <div class="ab-container">
            <div class="row">
                <div class="col-12 col-md-4 pl-0">
                    <div class="footer-logo-part">
                        <img class="footer-logo" alt="afterbricks-logo"
                        src="https://res.cloudinary.com/afterbricks/image/upload/v1643198020/logo/Group_2_ttgrew.svg" alt="afterbricks logo">

                    <div class="social-media " *ngIf="!_as.isOnMobilePlatform">
                        <span>Social</span>
                        <div class="social-links">
                            <a href="https://www.facebook.com/afterbricks" target="_blank" title="view on Facebook">
                              
                                    <i class="pi pi-facebook" aria-hidden="true"></i>
                            </a>
                            <a href="https://www.instagram.com/afterbricks/" target="_blank" title="view on Instagram">
                             
                                    <i class="pi pi-instagram " aria-hidden="true"></i>
                            </a>
                            <a href="https://in.pinterest.com/afterbricks/" target="_blank" title="view on Pinterest">
                                <i class="fa-brands fa-square-pinterest"></i>
    
                            </a>
                            <a href="https://www.linkedin.com/company/afterbricks/" target="_blank"
                                title="view on Linkedin">
                            
                                    <i class="pi pi-linkedin" aria-hidden="true"></i>
                            </a>
                            <a href="https://www.youtube.com/@afterbricks" target="_blank"
                            title="view on Linkedin">
                            <i class="pi pi-youtube" aria-hidden="true"></i>
                        </a>
                        </div>
                        
                    </div>
                    <p class="pt-1 hidden sm:block" *ngIf="_as.isOnMobilePlatform">
                        We make home renovation an informed, exciting and happy experience. Afterbricks is a unique,
                        first of its
                        kind, online platform which seamlessly brings home renovators closer to product
                        manufacturers and their
                        dealer ecosystem
                    </p>
                    </div>
                    
                </div>
                <div class="col-6 col-md-2 connect-part pr-0">
                    <div class="footer-links">
                        <h4>Connect</h4>
                        <ul>
                            <li>
                                <a href="https://blog.afterbricks.com" target="_blank" title="Afterbricks Blog">Blogs</a>
                            </li>
                            <li>
                                <a routerLink="/about" target="_self" title="About Us">About Us</a>
                            </li>
                            <li>
                                <a routerLink="/contact" target="_self" title="Contact Us">Contact Us</a>
                            </li>
                            <li>
                                <a (click)="displayFeedback=true" target="_self"title="Feedback">Feedback</a>
                            </li>
                            <li>
                                <a routerLink="/service-provider" target="_self" title="Professional">Professional</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-6 col-md-2  connect-part">
                    <div class="footer-links">
                        <h4>Help</h4>
                        <ul>
                           
                            <li>
                                <a routerLink="./faq" target="_self" title="Sourcing FAQ">Sourcing FAQ</a>
                            </li>
                            <li>
                                <a routerLink="./sample-faq" target="_self" title="Sample FAQ">Sample FAQ</a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="col-6 col-md-2  connect-part">
                    <div class="footer-links">
                        <h4>Consumer Policy</h4>
                        <ul>
                           
                            <li>
                                <a routerLink="/terms-and-condition" target="_self" title="Terms of Service">Terms of Service</a>
                            </li>
                            <li>
                                <a routerLink="/privacy-policy" target="_self" title="Privacy Policy">Privacy Policy</a>
                            </li>
                            <li>
                                <a routerLink="/refund-policy" target="_self" title="Refund Policy">Refund Policy</a>
                            </li>
                            <li>
                                <a routerLink="/shipping-policy" target="_self" title="Shipping Policy">Shipping Policy</a>
                            </li>
                            <li>
                                <a routerLink="/sourcing-terms" target="_self" title="Sourcing Terms & Conditions">Sourcing Terms & Conditions</a>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="col-6 col-md-2 ">
                    <div class="footer-links">
                        <h4>Business Login</h4>
                        <ul class="mt-0">
                            <li>
                                <a routerLink="/oem/form-first" target="_self" title="Manufacturers & Brands">Brands
                                    & Manufacturers </a>

                            </li>
                            <li>
                                <a href="https://pro.afterbricks.com/account/login" target="_blank"
                                    title="Professional">Service Providers</a>
                            </li>
                            <li>
                                <a href="https://partner.afterbricks.com" target="_blank" title="Dealer">Dealers</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 " *ngIf="_as.isOnMobilePlatform">
                    <div class="social-media ">
                        <span>Social</span>
                        <div class="social-links">
                            <a href="https://www.facebook.com/afterbricks" target="_blank" title="view on Facebook">
                                <!-- <img src="https://res.cloudinary.com/afterbricks/image/upload/v1642940031/homepage/Home_core_icon/XMLID_16_o80ien.png"
                                    alt="facebook"> -->
                                    <i class="pi pi-facebook" aria-hidden="true"></i>
                            </a>
                            <a href="https://www.instagram.com/afterbricks/" target="_blank" title="view on Instagram">
                                <!-- <img src="https://res.cloudinary.com/afterbricks/image/upload/v1642940018/homepage/Home_core_icon/XMLID_7_gcfal3.png"
                                    alt="Instagram"> -->
                                    <i class="pi pi-instagram " aria-hidden="true"></i>
                            </a>
                            <a href="https://in.pinterest.com/afterbricks/" target="_blank" title="view on Pinterest">
                                <i class="fa-brands fa-square-pinterest"></i>
    
                            </a>
                            <a href="https://www.linkedin.com/company/afterbricks/" target="_blank"
                                title="view on Linkedin">
                                <!-- <img src="https://res.cloudinary.com/afterbricks/image/upload/v1642940012/homepage/Home_core_icon/XMLID_1_wmupns.png"
                                    alt="Linkedin"> -->
                                    <i class="pi pi-linkedin" aria-hidden="true"></i>
                            </a>
                            <a href="https://www.youtube.com/@afterbricks" target="_blank"
                            title="view on Linkedin">
                            <i class="pi pi-youtube" aria-hidden="true"></i>
                        </a>
                        </div>
                        
                    </div>
                </div>
                <!-- <div class="col-3">
                    <div class="footer-links">
                        <h4>WANT FIRST DIBS?</h4>
                        <div class="mt-3">
                            <form autocomplete="off" class="subheadings pt-0 ">

                                <div class="signup-block-from">
                                    <input type="text" placeholder="Enter your email address" class="footer-input">
                                    <button>Submit</button>
                                </div>
                            </form>
                            <p class="signup-need-note">Note: You can opt-out at any time. See our <a
                                    routerLink="/terms-and-condition">Terms Of Services</a>
                            </p>
                        </div>
                    </div>
                </div> -->
            </div>
            </div>
        </div>
        <div class="footer-end col d-flex justify-content-center">

            <div>
                <span style="font-size: 12.9px;"> &#169; 2025, Afterbricks Consulting Private Limited, Tower-A, Urbtech Trade Center, 821, Sector 132, Noida, Uttar Pradesh 201305 India </span>
            </div>
            <!-- <div style="margin-left: 24px;font-size: 12.9px;">
                <a routerLink="/terms-and-condition" class="mr-2" target="_self" title="Terms & Condition">Terms Of Services</a>
                <a routerLink="/sourcing-terms" target="_self" title="Sourcing Terms and Conditions">Sourcing Terms and Conditions</a>
            </div> -->
        </div>
    <!-- </footer> -->

<!------------------------------FEEDBACK POPUP------------------------------------------------>
<div class="basic-info-popup">
    <p-dialog [(visible)]="displayFeedback" [modal]="true" [style]="{width: '600px'}" [baseZIndex]="10000"
     [transitionOptions]="_pop.dialogTransitionTime" [dismissableMask]="_pop.closeOutside" [showHeader]="false" [breakpoints]="{ '600px': '100%' }">
    <div class="close-popup" (click)="displayFeedback=false">
        <img alt="close" src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg">
    </div>
      <div class="ab-modal-heading" >
        <h3>Feedback</h3>
      </div>
    <form [formGroup]="feedbackForm" (ngSubmit)="feedbackSubmit(feedbackForm.value)" style="padding: 0px 2px">
        <div class="form-row">
            <div class="col-12 col-md-6 col-sm-12 mb-0 px-1">
                <label>Your Name *</label>
                <input type="text" formControlName="full_name" class="form-control " style="border-radius:0rem"
                    [ngClass]="{ 'is-invalid': f['full_name'].invalid && (f['full_name'].dirty || f['full_name'].touched) && submitted,
            'is-valid': f['full_name'].valid && (f['full_name'].dirty || f['full_name'].touched) && submitted}">

                <div *ngIf="submitted && f['full_name'].errors" class="invalid-feedback">
                    <div *ngIf="f['full_name'].errors['required']"> Full Name is required </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-sm-12 mb-0 px-1">
                <label for="validationServer01">Mobile </label>
                <input formControlName="mobile" type="tel" maxlength="10" class="form-control "
                    style="border-radius:0rem" numbersOnly 
                    [ngClass]="{ 'is-invalid': f['mobile'].invalid && (f['mobile'].dirty || f['mobile'].touched) && submitted,
            'is-valid': f['mobile'].valid && (f['mobile'].dirty || f['mobile'].touched) && submitted}">

                <div *ngIf="submitted && f['mobile'].errors" class="invalid-feedback">
                    <div *ngIf="f['mobile'].errors['pattern']"> Please, Enter valid mobile number</div>
                    <div *ngIf="f['mobile'].errors['maxLength']"> Please, Enter valid mobile number</div>
                </div>
            </div>
            <div class="col-12 mt-3 px-1">
                <label>Email *</label>
                <input type="text" formControlName="email" class="form-control " style="border-radius:0rem" 
                [ngClass]="{ 'is-invalid': f['email'].invalid && (f['email'].dirty || f['email'].touched) && submitted,
            'is-valid': f['email'].valid && (f['email'].dirty || f['email'].touched) && submitted}">
                <span class="text-danger"></span>
                <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                    <div *ngIf="f['email'].errors['required']"> Email is required </div>
                    <div *ngIf="f['email'].errors['email']"> Please, Enter valid email address</div>
                </div>
            </div>
            <div class="col-12 mt-3 px-1">
                <label>Please share your feedback what can we improve *</label>
                <textarea rows="4" cols="30" class="form-control" style="border-radius:0rem" pInputTextarea
                    autoResize="autoResize" formControlName="feedback"
                    [ngClass]="{ 'is-invalid': f['feedback'].invalid && (f['feedback'].dirty || f['feedback'].touched) && submitted,
            'is-valid': f['feedback'].valid && (f['feedback'].dirty || f['feedback'].touched) && submitted}"></textarea>
                <div *ngIf="submitted && f['feedback'].errors" class="invalid-feedback">
                    <div *ngIf="f['feedback'].errors['required']">Feedback is required </div>
                </div>

            </div>
        </div>
        <div class="row justify-content-center mt-2">

            <button class="btn feed-submit" type="submit">
                <span>Submit</span>
            </button>

        </div>
    </form>
</p-dialog>
  </div>
